/**
 * Minimal class joiner. This package is consumed by both apps and must not
 * import either app's `cn` helper (workspace-boundary rule), so it carries
 * its own dependency-free joiner. Conditionals use the object form, matching
 * the repo-wide `cn(...)` convention.
 */
export function cx(
  ...parts: Array<string | Record<string, boolean> | null | undefined>
): string {
  const classes: Array<string> = []
  for (const part of parts) {
    if (!part) {
      continue
    }
    if (typeof part === 'string') {
      classes.push(part)
      continue
    }
    for (const [name, isOn] of Object.entries(part)) {
      if (isOn) {
        classes.push(name)
      }
    }
  }
  return classes.join(' ')
}
